var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendNewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.172,
    height: 21.068,
    viewBox: "0 0 17.172 21.068",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "send-svgrepo-com",
    transform: "translate(8.019 -0.029) rotate(50)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4180",
    "data-name": "Path 4180",
    d: "M14.954.71a.5.5,0,0,1-.1.144L5.4,10.306l2.671,4.451a.5.5,0,0,0,.888-.06Z",
    fill: "#f9f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4181",
    "data-name": "Path 4181",
    d: "M4.694,9.6.243,6.929A.5.5,0,0,1,.3,6.04l13.99-6a.5.5,0,0,0-.147.1Z",
    fill: "#f9f7f7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendNewIcon);
export default __webpack_public_path__ + "static/media/send_new_icon.1454ec6d20aa9b4379b4a45ede11fadc.svg";
export { ForwardRef as ReactComponent };